export default {
    updateArticles: (state, payload) => state.articles = payload,
    updateFilter: (state, payload) => state.currentFilter = payload,
    updateLoadingState: (state, payload) => state.isLoading = payload 
}